'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationSdCard = function NotificationSdCard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
  );
};
NotificationSdCard = (0, _pure2.default)(NotificationSdCard);
NotificationSdCard.displayName = 'NotificationSdCard';
NotificationSdCard.muiName = 'SvgIcon';

exports.default = NotificationSdCard;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/notification/sd-card.js
 ** module id = 2301
 ** module chunks = 0
 **/